import { render } from "./NowIndicator.vue?vue&type=template&id=845d6914&scoped=true&ts=true"
import script from "./NowIndicator.vue?vue&type=script&lang=ts"
export * from "./NowIndicator.vue?vue&type=script&lang=ts"

import "./NowIndicator.vue?vue&type=style&index=0&id=845d6914&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845d6914"]])

export default __exports__